import { Landmark, TrendingUp } from 'lucide-react';
import type { FondoResumen } from '@condo/contracts';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { formatClp } from '@/lib/format/currency';
import { formatRelative, formatShortDate } from '@/lib/format/date';

interface FondoHeroProps {
  data: FondoResumen | undefined;
  isLoading: boolean;
}

export function FondoHero({ data, isLoading }: FondoHeroProps) {
  if (isLoading) {
    return (
      <Card>
        <CardContent className="flex items-center gap-6 p-8">
          <Skeleton className="h-14 w-14 rounded-full" />
          <div className="space-y-2">
            <Skeleton className="h-8 w-48" />
            <Skeleton className="h-4 w-64" />
          </div>
        </CardContent>
      </Card>
    );
  }

  const saldo = data?.saldoActual ?? 0;
  const ultimo = data?.ultimoMovimiento;

  return (
    <Card>
      <CardContent className="flex items-center gap-6 p-8">
        <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-[var(--color-primary-50)] text-[var(--color-primary)]">
          <Landmark className="h-7 w-7" />
        </div>
        <div>
          <p className="text-[0.6875rem] font-semibold uppercase tracking-[0.14em] text-[var(--color-ink-faint)]">
            Saldo fondo de reserva
          </p>
          <p className="font-display mt-1 text-3xl font-semibold tracking-tight text-[var(--color-ink)]">
            {formatClp(saldo)}
          </p>
          {ultimo ? (
            <p className="mt-2 flex items-center gap-1.5 text-xs text-[var(--color-ink-muted)]">
              <TrendingUp className="h-3.5 w-3.5" />
              Ultimo movimiento: {ultimo.descripcion}
              <span className="text-[var(--color-ink-faint)]">
                — {formatShortDate(ultimo.creadoEn)} ({formatRelative(ultimo.creadoEn)})
              </span>
            </p>
          ) : (
            <p className="mt-2 text-xs text-[var(--color-ink-muted)]">
              Sin movimientos registrados
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
